// ResetPassword.js
import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "./firebase";

export default function ResetPassword({ onBack }) {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleReset = async () => {
    setMessage("");
    setError("");
    try {
      await sendPasswordResetEmail(auth, email);
      setMessage("✅ Password reset email sent! Please check your inbox.");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="centered-outer">
      <div className="app-container">
        <h2>🔑 Reset Password</h2>
        <input
          type="email"
          placeholder="📧 Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button onClick={handleReset}>
          <span role="img" aria-label="reset">✉️</span> Send Reset Email
        </button>
        {message && <div className="success">{message}</div>}
        {error && <div className="error">{error}</div>}
        <button
          style={{
            background: "#f1f5f9",
            color: "#2563eb",
            fontWeight: 600,
            marginTop: "12px"
          }}
          onClick={onBack}
        >
          ← Back to Login
        </button>
      </div>
    </div>
  );
}
